import { render, staticRenderFns } from "./AvailabilityCollection.vue?vue&type=template&id=1ef74b50&scoped=true&"
import script from "./AvailabilityCollection.vue?vue&type=script&lang=js&"
export * from "./AvailabilityCollection.vue?vue&type=script&lang=js&"
import style0 from "./AvailabilityCollection.vue?vue&type=style&index=0&id=1ef74b50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef74b50",
  null
  
)

export default component.exports